import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
import FormLabel from "@material-ui/core/FormLabel";
import MUIDataTable from "mui-datatables";
import { NavLink } from "react-router-dom";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import MessageBox from "../../../components/MessageBox/MessageBox";
import { get_cookies, isLoggedIn } from "../../../components/Cookies/Cookies";
const useStyles = makeStyles((theme) => ({
  title: {
    marginTop: 0,
  },
  field: {
    width: "100%",
    marginBottom: "1rem",
  },
  autoComplete: {
    width: "100%",
    marginTop: "0",
    marginBottom: "0.5rem",
  },
  date: {
    width: "100%",
    marginBottom: "1rem",
  },
  buttonContainer: {
    textAlign: "right",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    maxWidth: "600px",
    margin: "0 auto",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: "800px",
  },
  button: {
    textAlign: "right",
    marginTop: "30px",
    "& .MuiButton-containedPrimary": {
      marginRight: "10px",
    },
  },

  buttonMarginRight: {
    marginRight: "0.5rem",
  },
}));

const PackageSalesInformation = (props) => {
  const classes = useStyles();
  const navid = props.location.pageInfo ? props.location.pageInfo.navid : "";
  const CurrentPage = props.location.pageInfo
    ? props.location.pageInfo.navname
    : "";
  const TransactionInformation = props.location.transactionInfo
    ? props.location.transactionInfo
    : "";
  // const isCORelease = props.location.isCORelease ? props.location.isCORelease : '';
  //ApiData Component useState SOF
  const [isCORelease, setIsCORelease] = useState([
    props.location.isCORelease ? props.location.isCORelease : "",
  ]);
  const [packages_list, loadPackagesDropdown] = useState([]);
  const [location_dropdown, loadLocationDropdown] = useState([]);
  const [branchIdNo, setBranchIdNo] = useState(get_cookies("branchidno"));
  const [branchCurcode, setBranchCurcode] = useState(get_cookies("curcode"));
  const [nextPagePath, setnextPagePath] = useState("");
  const [isLoaded, setisLoaded] = useState(false);
  const [maxPackageCount, setMaxPackageCount] = useState(0);
  const [defaultLocation, setSelectedWareHouse] = useState({
    id: TransactionInformation.warehouse,
    description: TransactionInformation.warehouse_desc,
  });
  const headers = {
    "Content-Type": "multipart/form-data",
  };

  const get_warehouse = () => {
    //get data for warehouse/location dropdown
    const formData = new FormData();
    formData.append("form_data", "");
    const apiUrl = process.env.REACT_APP_API_URL + "warehouse";
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      loadLocationDropdown(res.data.warehouse);
    });
  };
  const get_setpackages = () => {
    //get data for warehouse/location dropdown
    const form_data = {
      hqidno: branchIdNo,
      idno: TransactionInformation.activationcode,
      navid: navid,
    };
    const formData = new FormData();
    formData.append("form_data", JSON.stringify(form_data));
    const apiUrl = process.env.REACT_APP_API_URL + "packagelist_set";
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      loadPackagesDropdown(res.data.packages_list);
    });
  };
  const validate_packagecount = () => {
    //get data for warehouse/location dropdown
    //test query
    let url_function = "validate_packagecount";
    if (isCORelease == "yes") {
      url_function = "validate_packagecount2";
    }
    const form_data = {
      selectedpackages: TABLE_DATA,
      navid: navid,
    };
    const formData = new FormData();
    formData.append("form_data", JSON.stringify(form_data));
    const apiUrl = process.env.REACT_APP_API_URL + url_function;
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      if (res.data.result.success == 1) {
        if (isCORelease == "") {
          props.history.push(nextpage);
        } else {
          props.history.push(nextpageEncoding);
        }
      } else {
        setShowMsgBox(true);
        setMsg(res.data.result.message);
        setMsgType("warning");
        setTimeout(() => {
          setShowMsgBox(false);
        }, 3000);
      }
    });
  };
  let api_url = "getpackagecount";
  if (isCORelease == "yes") {
    api_url = "getpackagecount2";
  }

  const get_package_count = async () => {
    await axios
      .get(process.env.REACT_APP_API_URL + api_url, {
        params: {
          navid: navid,
        },
      })
      .then((res) => {
        setMaxPackageCount(res.data.result.package_max_count);
      })
      .catch((error) => {
        // console.log(error.message);
      });
  };
  const check_if_have_item = () => {
    const apiUrl = process.env.REACT_APP_API_URL + "does_have_item";
    const form_data = {
      navid: navid,
      curcode: branchCurcode,
    };
    const formData = new FormData();
    formData.append("form_data", JSON.stringify(form_data));
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      if (res.data.success == 1) {
        if (res.data.noofpackages > 0) {
          setnextPagePath(res.data.nextpagepath);
        } else {
          const itemNextPage = {
            // pathname: "/package-sales-payment",
            pathname: res.data.nextpagepath,
            transactionInfo: TransactionInformation, // your data array of objects
            selectedpackagesInfo: TABLE_DATA,
            pageInfo: {
              navid: navid,
              navname: CurrentPage,
            },
          };
          props.history.push(itemNextPage);
        }
      } else {
        setShowMsgBox(true);
        setMsg("Missing navigation ID");
        setMsgType("warning");
        setTimeout(() => {
          setShowMsgBox(false);
        }, 3000);
      }
    });
  };
  //ApiData Component useState EOF

  //Message Box
  const [showMsgBox, setShowMsgBox] = useState(false);
  const [msgBoxContent, setMsg] = useState("Empty");
  const [msgType, setMsgType] = useState("success");
  //Message Box EOF

  //Table Settings
  const [TABLE_DATA, setSelectedPackageTable] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState({});

  const onSelectPackage = () => {
    const newData = [...TABLE_DATA];
    let totalEnteredQty = selectedPackage.packageqty;
    if (newData != "") {
      totalEnteredQty =
        parseInt(newData.length) + parseInt(selectedPackage.packageqty);
    }
    const neededKeys = ["packageid", "packagename", "packageqty"];
    if (neededKeys.every((key) => Object.keys(selectedPackage).includes(key))) {
      if (
        totalEnteredQty <= maxPackageCount ||
        selectedPackage.packageqty == "" ||
        selectedPackage.packageqty == null
      ) {
        if (
          selectedPackage.packageqty <= 0 ||
          selectedPackage.packageqty == "" ||
          selectedPackage.packageqty == null
        ) {
          setShowMsgBox(true);
          setMsg("Please select atleast 1 package");
          setMsgType("warning");
          setTimeout(() => {
            setShowMsgBox(false);
          }, 3000);
        } else {
          for (let i = 0; i < selectedPackage.packageqty; i++) {
            const tempObj = {
              packageid: selectedPackage.packageid,
              packagename: selectedPackage.packagename,
            };
            newData.push(tempObj);
          }
        }
      } else {
        setShowMsgBox(true);
        setMsg("You exceed the maximum number of the packages included");
        setMsgType("warning");
        setTimeout(() => {
          setShowMsgBox(false);
        }, 3000);
      }
    } else {
      setShowMsgBox(true);
      setMsg("Please select atleast 1 package");
      setMsgType("warning");
      setTimeout(() => {
        setShowMsgBox(false);
      }, 3000);
    }
    setSelectedPackageTable([...newData]);
    setSelectedPackage({});
    handleClose();
  };

  const onPackageSelectionChange = (event) => {
    const newData = { ...selectedPackage };
    newData[event.target.name] = event.target.value;
    setSelectedPackage({ ...newData });
  };
  const refreshTable = () => {
    const newData = [...TABLE_DATA];
    setSelectedPackageTable([...newData]);
  };

  const TABLE_COLUMNS = [
    {
      name: "packageid",
      label: "ID",
    },
    {
      name: "packagename",
      label: "Package Name",
    },
    {
      name: "Delete",
      label: "Action",
      options: {
        filter: true,
        sort: false,
        empty: true,
        customBodyRender: (rowIndex, dataIndex) => {
          return (
            <Button
              variant="contained"
              color="primary"
              onClick={(e) => {
                updateSelectedPackages(dataIndex.rowIndex);
              }}
            >
              Delete
            </Button>
          );
        },
      },
    },
  ];

  const TABLE_OPTION = {
    filterType: "checkbox",
    selectableRows: "single",
    selectableRowsHideCheckboxes: true,
    selectableRowsOnClick: false,
    print: false,
    filter: false,
    download: false,
    viewColumns: false,
    onRowsDelete: (data) => {
      updateSelectedPackages(data.data[0].dataIndex);
    },
  };

  const updateSelectedPackages = (index) => {
    TABLE_DATA.splice(index, 1);
    refreshTable();
  };

  const selectLocationProps = {
    options: location_dropdown,
    getOptionLabel: (option) => option.description,
  };
  //Table Settings EOF
  const NumberKeyTrapper = (e) => {
    var a = [];
    var k = e.which;

    for (let i = 48; i < 58; i++) {
      a.push(i);
    }

    if (!(a.indexOf(k) >= 0)) {
      e.preventDefault();
    }
  };

  //Modal Settings
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedPackage("");
  };
  //Modal Settings EOF

  //OnLoad Event/Data Fetching SOF
  useEffect(() => {
    isLoggedIn();
    setisLoaded(false);
    check_if_have_item();
    get_warehouse();
    get_setpackages();
    setisLoaded(true);
    get_package_count();
  }, []);
  //OnLoad Event/Data Fetching SOF

  //Api Functions SOF
  // Code blocks here
  //Api Request Functions EOF

  const dropDownPackages = {
    options: packages_list,
    getOptionLabel: (option) => option.description,
  };
  //FormData
  const [prep_data, setData] = useState({});
  //FormData EOF
  const nextpage = {
    // pathname: "/package-sales-payment",
    pathname: nextPagePath,
    transactionInfo: TransactionInformation, // your data array of objects
    selectedpackagesInfo: TABLE_DATA,
    pageInfo: {
      navid: navid,
      navname: CurrentPage,
    },
  };

  const nextpageEncoding = {
    pathname: "/package-sales-packagesitem",
    transactionInfo: TransactionInformation, // your data array of objects
    selectedpackagesInfo: TABLE_DATA,
    pageInfo: {
      navid: navid,
      navname: CurrentPage,
    },
  };
  return !navid ? (
    <Redirect to="/package-sales" />
  ) : (
    <div className="page">
      <div className="page-header">
        <div className="page-icon">
          <ShoppingCartIcon />
        </div>
        <Breadcrumbs aria-label="breadcrumb">
          <NavLink to="/package-sales">
            <h2 className="header-title">Package Sales</h2>
          </NavLink>
          <Typography color="textPrimary">{CurrentPage}</Typography>
        </Breadcrumbs>
      </div>
      <div className="page-container">
        <form noValidate autoComplete="off">
          <MessageBox in={showMsgBox} content={msgBoxContent} type={msgType} />
          <Grid
            container
            spacing={2}
            alignItems="center"
            justify="center"
            className={classes.root}
          >
            <Grid item xs={12}>
              <Card>
                <CardContent>
                  <h4 className={classes.title}>Transaction Information</h4>
                  <h3 className={classes.title}>
                    {TransactionInformation.soldto}
                  </h3>
                  <Grid container>
                    <Grid item xs={12} sm={6}>
                      <Grid container>
                        <Grid xs={12} sm={3}>
                          <FormLabel>Activation Code:</FormLabel>
                        </Grid>
                        <Grid xs={12} sm={9}>
                          <FormLabel>
                            {TransactionInformation.activationcode}
                          </FormLabel>
                        </Grid>
                      </Grid>
                      <Grid container>
                        <Grid xs={12} sm={3}>
                          <FormLabel>Ref Code:</FormLabel>
                        </Grid>
                        <Grid xs={12} sm={9}>
                          <FormLabel>
                            {TransactionInformation.refcode}
                          </FormLabel>
                        </Grid>
                      </Grid>
                      <Grid container>
                        <Grid xs={12} sm={3}>
                          <FormLabel>Location:</FormLabel>
                        </Grid>
                        {isCORelease == "" ? (
                          <Grid xs={12} sm={9}>
                            <FormLabel>
                              {TransactionInformation.warehouse_desc}
                            </FormLabel>
                          </Grid>
                        ) : (
                          <Grid xs={12} sm={12}>
                            <Autocomplete
                              value={defaultLocation}
                              options={location_dropdown}
                              getOptionLabel={(option) => option.description}
                              autoComplete
                              includeInputInList
                              className={classes.autoComplete}
                              name="warehouse"
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  margin="normal"
                                  label="Location"
                                  variant="outlined"
                                  required="true"
                                />
                              )}
                              onChange={(event, newValue) => {
                                if (!newValue == "" || !newValue == null) {
                                  TransactionInformation["warehouse"] =
                                    JSON.stringify(newValue.id, null, " ");
                                  TransactionInformation["warehouse_desc"] =
                                    newValue.description;
                                }
                              }}
                            />
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Grid container>
                        <Grid xs={12} sm={3}>
                          <FormLabel>Shipping:</FormLabel>
                        </Grid>
                        <Grid xs={12} sm={9}>
                          <FormLabel>
                            {TransactionInformation.shipping_desc}
                          </FormLabel>
                        </Grid>
                      </Grid>
                      <Grid container>
                        <Grid xs={12} sm={3}>
                          <FormLabel>Primary Team:</FormLabel>
                        </Grid>
                        <Grid xs={12} sm={9}>
                          <FormLabel>
                            {TransactionInformation.primaryteam_desc}
                          </FormLabel>
                        </Grid>
                      </Grid>
                      <Grid container>
                        <Grid xs={12} sm={3}>
                          <FormLabel>Secondary Team:</FormLabel>
                        </Grid>
                        <Grid xs={12} sm={9}>
                          <FormLabel>
                            {TransactionInformation.secondaryteam_desc}
                          </FormLabel>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12}>
              <Card>
                <CardContent>
                  <Grid container spacing={2}>
                    <Grid xs={12}>
                      <div className={classes.button}>
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={handleOpen}
                          className={classes.buttonMarginRigh}
                        >
                          Add Package
                        </Button>
                      </div>
                    </Grid>
                    <Grid item xs={12}>
                      <MUIDataTable
                        title={
                          <div>
                            <div className="table-title">Selected Packages</div>
                          </div>
                        }
                        id="table-grid"
                        data={TABLE_DATA}
                        columns={TABLE_COLUMNS}
                        options={TABLE_OPTION}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs="12" className={classes.buttonContainer}>
              <Button
                variant="contained"
                color="primary"
                onClick={validate_packagecount}
              >
                Next
              </Button>
            </Grid>
          </Grid>
          <div>
            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              className={classes.modal}
              open={open}
              onClose={handleClose}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              <Fade in={open}>
                <div className={classes.paper}>
                  <h2 id="transition-modal-title">Add Package</h2>
                  <form action="" className={classes.root}>
                    <Grid container spacing={3}>
                      <Grid item xs={3}>
                        Packages
                      </Grid>
                      <Grid item xs={9}>
                        <Autocomplete
                          {...dropDownPackages}
                          autoComplete
                          includeInputInList
                          className={classes.autoComplete}
                          name="packagename"
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              margin="normal"
                              label="Packages"
                              variant="outlined"
                              required="true"
                            />
                          )}
                          onChange={(event, newValue) => {
                            if (!newValue == "" || !newValue == null) {
                              const newData = { ...selectedPackage };
                              newData["packageid"] = JSON.stringify(
                                newValue.id,
                                null,
                                " "
                              );
                              newData["packagename"] = newValue.description;
                              setSelectedPackage({ ...newData });
                            } else {
                              setSelectedPackage("");
                            }
                          }}
                        />
                      </Grid>
                      <Grid item xs={3}>
                        Quantity
                      </Grid>
                      <Grid item xs={9}>
                        <TextField
                          type="number"
                          required
                          name="packageqty"
                          label="Quantity"
                          variant="outlined"
                          inputProps={{ min: 0, max: 10000 }}
                          onKeyPress={NumberKeyTrapper}
                          onChange={onPackageSelectionChange}
                        />
                      </Grid>
                    </Grid>
                    <div className={classes.button}>
                      <Button
                        variant="contained"
                        onClick={handleClose}
                        className={classes.buttonMarginRight}
                      >
                        Close
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={onSelectPackage}
                      >
                        Add
                      </Button>
                    </div>
                  </form>
                </div>
              </Fade>
            </Modal>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PackageSalesInformation;
